












































import { Component, Vue, Prop } from "vue-property-decorator";
import request from "@/api/index";
import { INewsItem, IShareInfo } from "@/api/types";
@Component
export default class Header extends Vue {
  @Prop()
  private newsId!: string;
  @Prop()
  private bg!: string;
  @Prop()
  private location!: string;
  @Prop()
  private informationId!: string;
  private shareInfo: IShareInfo | {} = {};
  private isShow: boolean = true;
  public request: request = new request();
  private appId!: string;

  created() {
    if (ZWY_CLOUD.isOpenInApp()) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  }
  mounted() {
    this.appId = this.$route.query.appId as string;

    this.request.getAppInfoConfigList().then((response: any) => {
      if (response) {
        const list = response.data;
        list.forEach((element: any) => {
          if (this.appId == element.appId) {
            element.shareInfo
              ? (this.shareInfo = element.shareInfo)
              : this.request.getShareInfoMethod(this.appId).then(result => {
                  this.shareInfo = result.data;
                });
          }
        });
      }
    });
  }

  beforeDestroy() {
    this.close();
  }
  close() {
    this.isShow = false;
  }

  openApp() {
    let newsId = this.$route.query.id
      ? (this.$route.query.id as string)
      : (this.$route.query.cid as string) || "";
    const shareInfo = this.shareInfo as IShareInfo;
    if (!shareInfo.schemeUrl) {
      return (location.href = shareInfo.downloadUrl);
    }
    const videoFormat = this.$route.path == "/video/vertical-video" ? 2 : -1;
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      const Params = {
        id: newsId,
        sourceId: newsId,
        sourceType: "1",
        url: location.href,
        shareUrl: location.href,
        videoFormat: videoFormat, // videoFormat 竖屏新闻传2  别的为-1
        urlType: "1" // 1 新闻; 2 活动;   都传string
      };
      location.href = `${shareInfo.schemeUrl}/info/install/${this.appId}.html?id=${newsId}&&&sourceId=${this.informationId}&&&sourceType=1&&&url=${location.href}&&&shareUrl=`;
    } else if (/(Android)/i.test(navigator.userAgent)) {
      const Params = {
        id: newsId,
        sourceId: newsId,
        sourceType: "1",
        url: location.href,
        shareUrl: location.href,
        videoFormat: videoFormat, // videoFormat 竖屏新闻传2  别的为-1
        urlType: "1" // 1 新闻; 2 活动;   都传string
      };
      let schemeUrl = shareInfo.schemeUrl.split("/");
      location.href = schemeUrl[2] + `://?params=${JSON.stringify(Params)}`;
      setTimeout(() => {
        location.href = shareInfo.downloadUrl;
      }, 3000);
    } else {
      location.href = shareInfo.downloadUrl;
    }
  }
}
